import React from "react";
import "./Main.css";
function Education() {
  return (
    <div>
      <div className="colleges">
        <div className="geeks">
          <i className="fa-solid fa-graduation-cap"></i>
          <p>
            Junior Secondary <br />
            Dehradun Public School
            <br />
            <small>2018, 90.2%</small>
          </p>
        </div>
        <div className="geeks">
          <i className="fa-solid fa-graduation-cap"></i>
          <p>
            Senior Secondary <br />
            Dehradun Public School
            <br />
            <small>2020, 94.6%</small>
          </p>
        </div>
        <div className="geeks">
          <i className="fa-solid fa-graduation-cap"></i>
          <p>
            Bachelors of Technology
            <br />
            Ajay Kumar Garg Engineering College
            <br />
            <small>2024, 8.66 CGPA</small>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Education;
